import React from "react";

import { css } from "@emotion/css";
import { desktop, laptop, tablet } from "../../../styles/breakpoints";

import ICON1 from "../../../img/svg/home/why/icon1.svg";
import ICON2 from "../../../img/svg/home/why/icon2.svg";
import ICON31 from "../../../img/svg/home/why/icon31.svg";
import ICON32 from "../../../img/svg/home/why/icon32.svg";
import ICON4 from "../../../img/svg/home/why/icon4.svg";
import ICON5 from "../../../img/svg/home/why/icon5.svg";
import ICON6 from "../../../img/svg/home/why/icon6.svg";
import { useI18n } from "../../../i18n";

const Why = () => {
  const { t } = useI18n();
  return (
    <div style={{ position: "relative", background: "#000" }}>
      <div className={style.container}>
        <h2>
          {t("home_why_title")}
          <br />
          {t("home_why_zilouet")}
        </h2>

        <div className="wrapper">
          <div className={`item i1`}>
            <img src={ICON5} alt="" />
            <h5>{t("home_why_precision")}</h5>
            <p>
              {t("home_why_precision_body")}
            </p>
          </div>
          <div className={`item i2`}>
            <img src={ICON2} alt="" />
            <h5>
              {t("home_why_style_title")}
              <br />
              {t("home_why_style_sub")}
            </h5>
            <p>
              {t("home_why_style_body")}
            </p>
          </div>
          <div className={`item i3`}>
            <img src={ICON32} alt="" className="bg" />
            <img src={ICON31} alt="" className="icon" />
            <h5>{t("home_why_customised")}</h5>
            <p>
              {t("home_why_customised_body")}
            </p>
          </div>
          <div className={`item i4`}>
            <img src={ICON4} alt="" />
            <h5>{t("home_why_tryon")}</h5>
            <p>
              {t("home_why_tryon_body1")}
              <br />
              <br />
              {t("home_why_tryon_body2")}
            </p>
          </div>
          <div className={`item i5`}>
            <img src={ICON1} alt="" />
            <h5>{t("home_why_size")}</h5>
            <p>
              {t("home_why_size_body1")}
              <br />
              <br />
              {t("home_why_size_body2")}
            </p>
          </div>
          <div className={`item i6`}>
            <img src={ICON6} alt="" />
            <h5>{t("home_why_wardrobe")}</h5>
            <p>
              {t("home_why_wardrobe_body1")}
              <br />
              <br />
              {t("home_why_wardrobe_body2")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const style = {
  container: css({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignContent: "flex-start",
    flexWrap: "nowrap",
    justifyContent: "flex-start",
    alignItems: "center",
    maxWidth: 1172,
    margin: "auto",
    padding: 40,
    backgroundColor: "#000000",
    paddingTop: 120,
    paddingBottom: 180,
    marginBottom: 0,
    zIndex: 1,

    h2: {
      textAlign: "center",
      fontFamily: "Syne",
      fontSize: 71.744,
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "97px",
      textTransform: "uppercase",
      marginBottom: 93,
      color: "#fff",
      zIndex: 1,
    },
    ".wrapper": {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",
      gap: 31,

      ".item": {
        position: "relative",
        borderRadius: 60,
        justifyContent: "flex-start",
        alignItems: "flex-start",
        alignSelf: "stretch",
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        alignContent: "center",
        width: 353,

        img: {
          position: "absolute",
          width: "100%",
          height: "100%",
          top: 0,
        },

        "&.i1": {
          background: "#F7E9DC",
          order: 1,

          img: {
            top: -130,
          },
        },
        "&.i2": {
          background: "#A8EF12",
          order: 2,

          img: {
            width: 230.195,
            height: 230.186,
            left: 0,
            right: 0,
            top: 50,
            margin: "auto",
          },
        },
        "&.i3": {
          background: "#FF6AFF",
          order: 3,

          ".bg": {
            zIndex: 0,
          },
          ".icon": {
            width: 190.062,
            height: 259.605,
            left: 40,
            top: -20,
          },
        },
        "&.i4": {
          background: "#FF8E0A",
          order: 4,

          img: {
            top: -140,
            width: "107%",
            left: -15,
            right: -15,
          },
        },
        "&.i5": {
          background: "#8845E9",
          order: 5,

          img: {
            top: -180,
            left: -10,
          },
        },
        "&.i6": {
          background: "#FAD414",
          order: 6,

          img: {
            top: -155,
            width: "103%",
            left: -10,
          },
        },

        h5: {
          color: "#000",
          fontFamily: "Syne",
          fontSize: 30,
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "normal",
          marginBottom: 15,
          padding: "0 26px",
          paddingTop: 312,
          paddingBottom: 7,
          zIndex: 1,
        },
        p: {
          color: "#000",
          fontFamily: "Inter",
          fontSize: 13,
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "normal",
          letterSpacing: 0.13,
          padding: "0 26px",
          paddingBottom: 50,
          zIndex: 1,
        },

        ".icon-wrapper": {
          gap: 16,
          display: "flex",
          flexDirection: "row",
          flexWrap: "nowrap",
          justifyContent: "flex-start",
          alignItems: "center",

          img: {
            width: "100%",
          },
        },
      },
    },
    [desktop]: {
      height: "100%",
      maxWidth: 923,
      padding: 40,
      paddingTop: 120,
      paddingBottom: 180,

      h2: {
        color: "#FFF",
        textAlign: "center",
        fontFamily: "Syne",
        fontSize: 74,
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "89.323px",
        textTransform: "uppercase",
        marginBottom: 100,
      },
      ".wrapper": {
        gap: 30,

        ".item": {
          width: 347,

          h5: {
            fontSize: 30,
            paddingTop: 287,
          },
          p: {
            fontSize: 16,
          },
          "&.i2": {
            order: 3,
          },
          "&.i3": {
            order: 2,
          },
          "&.i6": {
            background: "#FAD414",

            img: {
              top: -177,
            },
          },
        },
      },
    },
    [laptop]: {
      height: "100%",
      maxWidth: 668,
      padding: 40,
      paddingTop: 80,
      paddingBottom: 80,

      h2: {
        textAlign: "center",
        fontFamily: "Syne",
        fontSize: 60,
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "72px",
        textTransform: "uppercase",
        marginBottom: 80,
      },
      ".wrapper": {
        gap: 26,

        ".item": {
          width: 320,

          h5: {
            fontSize: 26,
            paddingTop: 287,
          },
          p: {
            fontSize: 14,
          },

          "&.i6": {
            background: "#FAD414",

            img: {
              top: -167,
            },
          },
        },
      },
    },
    [tablet]: {
      height: "100%",
      maxWidth: 336,
      padding: 40,
      paddingTop: 40,
      paddingBottom: 60,

      h2: {
        fontSize: 42,
        lineHeight: "50px",
        marginBottom: 47,
      },
      ".wrapper": {
        gap: 50,

        ".item": {
          width: 320,

          h5: {
            fontSize: 26,
            paddingTop: 260,
          },
          p: {
            fontSize: 12,
          },

          "&.i1": {
            img: {
              top: -110,
            },
          },
          "&.i2": {
            img: {
              width: 210.951,
              height: 210.943,
              top: 20,
            },
          },
          "&.i6": {
            background: "#FAD414",

            img: {
              top: -133,
              width: "103%",
              left: -10,
            },
          },
        },
      },
    },
  }),
};

export default Why;
